export type EmailConfirmResponse = {
  email: string;
};
